'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var i18n = require('utils/i18n');

var MailboxListView = AbstractTableView.extend({
    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click #js-add': 'addNewMailbox',
            'click .js-edit-mailbox': 'updateMailbox',
        });
    },

    collectionEvents: {
        sync: function () {
            this.render();
        },
        change: function () {
            this.render();
        },
    },

    initialize: function (options) {
        this.controller = options.controller;
        AbstractTableView.prototype.initialize.apply(this, [
            {
                title: i18n.TR('Postfächer'),
                columns: [
                    { id: '#_name', name: 'Name', alwaysVisible: false }, // i18n.TR('Name')
                    { id: '#_targets', name: 'E-Mail Adressen / Telefonnummern', alwaysVisible: true }, // i18n.TR('E-Mail Adressen / Telefonnummern')
                    { id: '#_alarms', name: 'Alarme', alwaysVisible: false }, // i18n.TR('Alarme')
                    { id: '#_reports', name: 'Berichte', alwaysVisible: false }, // i18n.TR('Berichte')
                ],
                hasRefreshButton: true,
                hasSelectionButtons: true,
                selectionButtons: [{ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete' }],
                customButtons: [{ ButtonIcon: 'fa fa-plus', ButtonID: 'add' }],
                emptyView: this.controller.EmptyMailboxView,
            },
        ]);
    },

    setPermission: function (permissions) {},

    addNewMailbox: function () {
        this.controller.showMailboxDialog({
            title: i18n.TR('Neues Postfach'),
            collection: this.collection,
            view: this,
        });
    },

    updateMailbox: function (e) {
        e.preventDefault();

        var id = $(e.currentTarget).attr('id');
        var model = this.collection.get(id);

        this.controller.showMailboxDialog({
            title: i18n.TR('Postfach bearbeiten'),
            name: model.get('name'),
            collection: this.collection,
            model: model,
            view: this,
        });
    },

    updateSelectionButtons: function () {
        this.ui.btnsSelection.addClass('disabled');

        var selectionContainsUsedMailboxes =
            _.filter(this.collection.selected, function (e) {
                return e.get('alarms') !== 0 || e.get('reports') !== 0;
            }).length != 0;

        // enable button only if all selected mailboxes are unused
        if (this.collection.selectedLength > 0 && !selectionContainsUsedMailboxes) {
            this.ui.btnsSelection.removeClass('disabled');
        }
    },

    afterDeleteSelectedRows: function () {
        Backbone.history.loadUrl(Backbone.history.fragment);
    },
});

module.exports = MailboxListView;
